import { Link } from 'react-router-dom';
import { useSeo } from '../lib/seo.js';
import { SITE_NAME } from '../components/Layout.js';

export function NotFound({
  title = 'Page not found',
  message = "We couldn't find that page.",
}: {
  title?: string;
  message?: string;
}) {
  useSeo({ title: `${title} | ${SITE_NAME}`, robots: 'noindex,follow' });
  return (
    <div className="wrap page-pad">
      <div className="card narrow center-card">
        <h1 className="h2">{title}</h1>
        <p className="muted">{message}</p>
        <Link to="/" className="btn btn-primary">
          Find an astrologer
        </Link>
      </div>
    </div>
  );
}
